import React from 'react';
import _ from 'lodash';
import styles from './MobileMenu.module.scss';
import mobileNavigationStyles from './MobileNavigation.module.scss';
import { GlobalIcon, IconImage } from 'src/modules/global';
import { Col, Row } from 'antd';
import { rowDefaultProps } from 'src/utils/grid';
import Image from 'src/modules/global/components/image/Image';
import classnames from 'classnames';
import ScrollBound from 'react-scroll-bound';
import Link from 'next/link';
import { NavMainMenuLink } from '../components/NavMainMenu';

export interface MobileMenuCard {
  title: string;
  imageUrl: string;
  linkUrl: string;
}

export interface MobileMenuMoreLink {
  text: string;
  url: string;
}

export interface MobileMenuProps {
  title: string;
  name: string;
  activeMenu: string;
  setActiveMenu: (menuName: string) => void;
  onClose: () => void;
  cards?: MobileMenuCard[];
  links?: NavMainMenuLink[];
  moreLink?: MobileMenuMoreLink;
}

// Manually add hyphens to some titles since the automatic CSS hyphen property
// adds the hyphen in a undesirable location. Also, better not to add \u00AD to
// the field in the CMS since the title field is used in other components.
const addHyphensToTitle = (title: string) => {
  if (!_.isString(title)) return title;

  if (title.match(/schreibtischprogramme/gi)) {
    return 'Schreibtisch\u00ADprogramme';
  }

  return title;
};

export const MobileMenu = ({
  title,
  name,
  activeMenu,
  setActiveMenu,
  cards,
  links,
  moreLink,
  onClose,
}: MobileMenuProps) => {
  return (
    <ScrollBound
      tagName="div"
      className={classnames(styles.menu, activeMenu === name && styles.open)}>
      <div className={styles.backButton} onClick={() => setActiveMenu('')}>
        <GlobalIcon image={IconImage.LeftArrow} size="custom" className={styles.backIcon} />
        {title}
      </div>
      {!!cards && (
        <Row {...rowDefaultProps}>
          {cards.map((card, i) => (
            <Col key={`card-${i}`} span={12}>
              <Link href={card.linkUrl}>
                <a className={styles.card} onClick={onClose}>
                  <Image ratio={1.5} url={card.imageUrl} />
                  <h4 className={styles.cardTitle}>{addHyphensToTitle(card.title)}</h4>
                </a>
              </Link>
            </Col>
          ))}
        </Row>
      )}
      {!!links && (
        <div className={mobileNavigationStyles.buttonsContainer}>
          {links.map((link, i) => {
            if (link?.linkType === 'divider') {
              return <div className={styles.linkDivider} />;
            }
            return (
              <Link key={i} href={link.url}>
                <a className={styles.linkButton}>
                  <span>{link.text}</span>
                </a>
              </Link>
            );
          })}
        </div>
      )}
      {moreLink && (
        <a href={moreLink.url} className={styles.moreLink}>
          {moreLink.text}
        </a>
      )}
    </ScrollBound>
  );
};
